<template>
    <div class="booklistPage">
      <v-menu></v-menu>
      <div class="pagebg">
        <div class="videoage bookpage">
          <div class="bread_nav">
            <div class="line"></div>
            <div class="bread_nav_left">
              <div class="bread_item" :class="{'down':down==1}">
                <div class="titlebox"  @click.stop="showBookMore">
                  {{showtxt}}
                  <div class="img"></div>
                </div>
                <ul>
                  <li v-for="item in author" @click="changeBookList(item)">{{item.name}}（{{item.pdfNum}}）</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="booklist left">
            <div class="book_item left" v-for="(item,index) in bookList">
              <a @click="readBook(item)">
                <div class="book_img left">
                  <img class="bookimg" :src="item.image" :alt="item.className" :title="item.className">
                </div>
                <div class="boot_content left">
                  <div class="book_title textover">《{{item.className}}》</div>
                  <div class="book_area">
                   {{item.pdf_desc}}
                  </div>
                </div>
                <div class="clear clearfix"></div>
              </a>
            </div>
          </div>
          <div class="clear clearfix"></div>
          <div class="nobook" v-if="!loadMode&&bookList.length<=0">
            <img src="../../../assets/images/nobook.png" alt="暂无书籍" title="暂无书籍">
            <div class="notxt">暂无书籍</div>
          </div>
        </div>

        <div class="page" v-if="!loadMode && bookList.length > 0">
          <template v-if="count">
            <mo-paging
              :page-index="currentPage"
              :total="count"
              :page-size="pageSize"
              @change="pageChange">
            </mo-paging>
          </template>
        </div>
        <!--没有搜索到相关书籍-->
        <transition name="fade">
          <div class="pagemode modehide"  v-if="bookRes==1">
            <div class="novideo">
              <div class="novideo_main" >
                <div class="txt">暂无书籍</div>
                <div class="close" @click="hideSearch">
                  <img src="../../../assets/images/close.png" alt="关闭" title="关闭">
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <mode v-if="loadMode"></mode>
      <v-footer></v-footer>
    </div>
</template>

<script>
  import MoPaging from '@/components/page/page'
  import mode from '@/components/bg/mode'
    export default {
        name: "book",
      //显示的声明组件
      components : {
        MoPaging, mode
      },
        data() {
            return {
              down:0,
              pageSize : 6 , //每页显示6条数据
              currentPage : 1, //当前页码
              count : 0, //总记录数
              loadMode:false,
              bookList:[],
              bookRes:0,
              bookPrimary:'',
              author:[],
              showtxt:'书库'
            }
        },
        mounted() {
          this.getBookancestor()

          // this.getList()
        },
        methods: {
          showBookMore(){
            if(this.down==0){
              this.down=1
            }else{
              this.down=0
            }
            // this.getList()
          },
          getBookancestor(){
            this.loadMode=true
            this.$http({
              url: '/Book/ancestor',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {ajax:1}
            }).then((res) => {
              console.log(res)
              if(res.data.code==0){
                let allNum=0
                res.data.data.map((item,index,arr)=>{
                  allNum+=item.pdfNum
                })
                this.author=res.data.data
                this.author.unshift({id:0,name:'书库',pdfNum:allNum})
                this.getList()
              }else{
                this.$layer.msg(res.data.msg)
              }
            })
              .catch((error) => {
                // error
                this.$layer.msg('网络错误，请稍后重试')
                this.loadMode=false
                console.log(error)
              })
          },
          changeBookList(item){
            this.down=0
            this.showtxt=`${item.name}`
            this.bookPrimary=item.id
            this.getList()
          },
          getList(){
            this.loadMode=true
            this.$http({
              url: '/Book/list',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {id:this.bookPrimary,page:this.currentPage}
            }).then((res) => {
              console.log(res)
              this.loadMode=false
              if(res.data.code==0){
                this.count=res.data.data.count
                res.data.data.data.map((item,index,arr)=>{
                  console.log(item)
                  console.log(item.pdf_summary)
                  console.log(item.pdf_summary.length)
                  if(item.pdf_summary.length>100){
                    item.pdf_desc=item.pdf_summary.substr(0,100)+'……';
                  }else{
                    item.pdf_desc=item.pdf_summary;
                  }
                  return this.bookList=res.data.data.data
                })
                console.log(this.bookList)
                console.log(this.count)
              }else{
                this.$layer.msg(res.data.msg)

                this.bookList=[]
              }
            })
              .catch((error) => {
                // error
                this.$layer.msg('网络错误，请稍后重试')
                this.loadMode=false
                console.log(error)
              })
          },
          pageChange (page) {
            console.log(page)
            this.currentPage = page
            this.getList()
          },
          searchBook(){
            this.currentPage=1
            this.getList()
          },
          readBook(item){
            // window.open(item.pdf_content)
            this.$router.push({name:'pcbookdetail',params:{id:item.id}})
          }
        }
    }
</script>

<style scoped lang="scss">
  .videoage{
    width:95rem;
    margin:0 auto 0;
    padding-left:9rem;
    box-sizing: border-box;
    position: relative;
    /*height:calc(100% - 12rem);*/
    .nobook{
      position: fixed;
      top:0;
      bottom:0;
      left:0;
      right:0;
      margin:auto;
      width:11rem;
      height:12rem;
      img{
        display: block;
        width:11rem;
      }
      .notxt{
        text-align: center;
        color:#b68c51;
        font-size:1.1rem;
        padding-top:1rem;
      }
    }
    .bread_nav{
      padding-top:3.5rem;
      position: absolute;
      top:0;
      left:9rem;
      width:100%;
      .line{
        position: absolute;
        top:6.5rem;
        left:1px;
        width:100%;
        height:1px;
        background: #c9a168;
      }
      .bread_nav_left{
        width:100%;
        position: relative;
      }
      .down{
        max-height: 20rem !important;
        overflow-y: auto;
        .img{
          transform: rotate(90deg);
        }
      }
      .bread_item{
        width:100%;
        max-height:3rem;
        overflow: hidden;
        transition: max-height 0.5s;
        position: relative;
        height:20rem;
        .titlebox{
          width:14rem;
          height:3rem;
          background: #c9a168;
          /*padding-left:4.4rem;*/
          text-align: center;
          line-height: 3rem;
          box-sizing: border-box;
          color:#fff;
          cursor: pointer;
          border-top-left-radius:4px;
          border-top-right-radius:4px;
          position: relative;
          font-size:1.3rem;
          display: flex;
          justify-content: center;
          align-items: center;
          /*display: flex;*/
          /*justify-content: center;*/
          /*align-items: center;*/
          .img{
            background: url("../../../assets/images/iconright.png")no-repeat left center;
            background-size:0.8rem auto;
            transition: transform 0.5s;
            margin-left:1rem;
            /*position: absolute;*/
            left:8.5rem;
            width:0.8rem;
            height:100%;
            top:0;
          }
          .tit{
            font-size:1.2rem;
            display: inline-block;
            vertical-align: middle;
          }
          img{
            width:0.8rem;
            padding-left:1rem;

            display: inline-block;
            vertical-align: middle;
          }
        }
        ul{
          width:14rem;
          position: absolute;
          top:3rem;
          left:0;
          z-index:1;
          li{
            border-bottom:1px dashed #d5c5ae;
            background:rgba(201,161,104,0.9);
            font-size:1.3rem;
            color:#fff;
            text-align: center;
            height:3rem;
            line-height: 3rem;
            cursor: pointer;
          }
          li:last-child{
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            border-bottom:none;
          }
        }
      }
      .search{
        width:27rem;
        height:100%;
        input{
          width:27rem;
          height:3rem;
          border-radius:0.4rem;
          border:1px solid #c9a168;
          padding-left:4rem;
          box-sizing: border-box;
          background: url("../../../assets/images/search.png")no-repeat 1rem center #fff;
          background-size:1.5rem auto;
          font-size:1.2rem;
        }
      }
    }
    .booklist{
      height:calc(100% - 5rem);
      overflow-y: auto;
      padding-top:6.5rem;
      box-sizing: border-box;
      /*margin-top:2.2rem;*/
      .book_item{
        position: relative;
        width:47%;
        margin-right:6%;
        margin-top:2.8rem;
        a{
          display:block;
        }
        .book_img{
          position: absolute;
          top:0;
          left:0;
          width:10rem;
          height:15rem;
          .bookimg{
            width:10rem;
            height:15rem;
            display: block;
          }
        }
        .boot_content{
          padding-left:12rem;
          height:15rem;
          .book_title{
            font-size:1.6rem;
            color:#333;
            line-height: 3rem;
          }
          .book_area{
            font-size:1.1rem;
            color:#666;
            padding-top:1rem;
            box-sizing: border-box;
            height:12rem;
            line-height: 2rem;
            overflow: hidden;
          }
        }
      }
      .book_item:nth-child(even){
        margin-right:0;
      }
    }
  }
  .page{
    padding:4rem 0 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/book/booklist.vue